import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/site/Reveal";
import { RevealTextInstant } from "@/components/site/RevealText";
import { SERVICES } from "@/lib/data";

export default function ServicesPage() {
  const { t } = useLang();
  return (
    <div data-testid="page-services" className="pt-32 md:pt-40">
      <section className="mx-auto max-w-[1440px] px-6 md:px-10 pb-16 md:pb-24">
        <div className="grid grid-cols-12 gap-6 mb-10">
          <div className="col-span-12 md:col-span-3 az-tag"><span className="az-tag__dot" /><span>{t.services.kicker}</span></div>
          <div className="col-span-12 md:col-span-3 md:col-start-10 md:text-right font-mono text-[10px] tracking-widest uppercase text-[#86868B]">
            10 / {t.services.kicker}
          </div>
        </div>
        <RevealTextInstant
          as="h1"
          lines={[t.services.title]}
          className="font-serif tracking-tighter leading-[0.94] text-[10vw] md:text-[6vw] lg:text-[5.5rem]"
          lineClassName="block"
        />
        <div className="mt-10 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <Reveal delay={0.15}>
              <p className="font-sans text-lg md:text-xl leading-relaxed text-[#86868B] max-w-[56ch]">
                {t.services.lead}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[#E5E5EA]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
          {SERVICES.map((s, i) => {
            const item = t.services.items[s.id];
            return (
              <Reveal key={s.id} delay={i * 0.02}>
                <article className="grid grid-cols-12 gap-6 md:gap-10 py-14 md:py-24 border-b border-[#E5E5EA]" data-testid={`service-${s.id}`}>
                  <div className="col-span-12 md:col-span-1 font-mono text-[11px] tracking-widest uppercase text-[#86868B]">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="col-span-12 md:col-span-5">
                    <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-[1.05]">{item.title}</h2>
                    <div className="mt-6 relative aspect-[4/3] overflow-hidden bg-[#0A0A0A]">
                      <img src={s.image + "?auto=format&fit=crop&w=1200&q=80"} alt={item.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    </div>
                  </div>
                  <div className="col-span-12 md:col-span-5 md:col-start-8 space-y-8">
                    <div>
                      <div className="font-mono text-[10px] tracking-widest uppercase text-[#0055FF] mb-2">{t.services.pcs.problem}</div>
                      <p className="font-sans text-base md:text-lg text-[#0A0A0A] leading-relaxed">{item.problem}</p>
                    </div>
                    <div>
                      <div className="font-mono text-[10px] tracking-widest uppercase text-[#0055FF] mb-2">{t.services.pcs.solution}</div>
                      <p className="font-sans text-base md:text-lg text-[#0A0A0A] leading-relaxed">{item.solution}</p>
                    </div>
                    <div>
                      <div className="font-mono text-[10px] tracking-widest uppercase text-[#0055FF] mb-2">{t.services.pcs.result}</div>
                      <p className="font-sans text-base md:text-lg text-[#0A0A0A] leading-relaxed">{item.result}</p>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#F5F5F7] border-t border-[#E5E5EA]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <h3 className="font-serif text-4xl md:text-6xl tracking-tighter max-w-[22ch] leading-[0.98]">
            {t.home.contactTitle}
          </h3>
          <Link to="/contact" className="az-btn" data-testid="services-contact-cta">
            <span>{t.nav.cta}</span>
            <span className="az-btn__arrow" aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
    </div>
  );
}
